<template>
  <Layout>
    <FilterPanel :modelValue="filter" @update:modelValue="setFilter" />
    <template v-if="!filter.territory.alias">
      <ValidDocumentQuantityByTerritoryChart :filter="filter" />
    </template>
    <template v-else>
      <DocumentManagementQualityTable :filter="filter" />
    </template>
  </Layout>
</template>

<script>
import useDocumentsFilter from "@/components/documents/filter";
import Layout from "./Layout";
import ValidDocumentQuantityByTerritoryChart from "@/components/documents/ValidDocumentQuantityByTerritoryChart";
import DocumentManagementQualityTable from "@/components/documents/DocumentManagementQualityTable";
import FilterPanel from "@/components/common/FilterPanel";

export default {
  components: {
    Layout,
    FilterPanel,
    ValidDocumentQuantityByTerritoryChart,
    DocumentManagementQualityTable,
  },
  setup() {
    const { filter, setFilter } = useDocumentsFilter();

    return {
      filter,
      setFilter,
    };
  },
};
</script>
